import React, { useState, useEffect } from 'react';
import { fetchMarketNews } from '../services/api'; // Correctly import fetchMarketNews

const NewsFeed = () => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const getNews = async () => {
      try {
        const news = await fetchMarketNews();
        setNewsArticles(news);
        setError('');
      } catch (err) {
        setError('Failed to fetch news. Please try again later.');
        console.error(err);
      }
    };

    getNews();
  }, []);

  return (
    <div className="news-feed">
      <h3>Market News</h3>
      {error && <p>{error}</p>}
      <ul>
        {newsArticles.map((article, index) => (
          <li key={index}>
            <a href={article.url} target="_blank" rel="noopener noreferrer">
              {article.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NewsFeed;
